import { PayloadAction } from '@reduxjs/toolkit'

import { GetUsersResponse } from '../api/types'

import { StateType } from './initialState'

export const GetUsersReducer = {
  pending: (state: StateType) => ({
    ...state,
    loading: 'pending',
  }),
  fulfilled: (state: StateType, action: PayloadAction<GetUsersResponse>) => ({
    ...state,
    list: action.payload.data.data,
    pagination: { ...state.pagination, ...action.payload.data.meta },
    loading: 'succeeded',
  }),
  rejected: (state: StateType) => ({
    ...state,
    loading: 'failed',
  }),
}
